import React from 'react';
import ScrollingBanner from './ScrollingBanner';
import WeatherEffect from './WeatherEffect';

const HomePage = ({ config, onContactClick }) => {
  return (
    <div 
      className="home-page"
      style={{
        backgroundImage: `url(${config.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat:  'no-repeat',
        height: '100vh',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      {/* Overlay pour améliorer la lisibilité */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 1
      }} />

      {/* Effet météo */}
      <WeatherEffect effect={config.weatherEffect} />

      {/* Titre centré */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        textAlign: 'center'
      }}>
        <h1 style={{
          color: 'white',
          fontSize: '3.5rem',
          fontWeight:  'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
          margin: 0,
          padding: '0 20px'
        }}>
          {config.title}
        </h1>
      </div>

      {/* Bouton Me Contacter */}
      <button
        onClick={onContactClick}
        style={{
          position:  'absolute',
          top:  '20px',
          right:  '20px',
          zIndex: 11,
          backgroundColor: config.secondaryColor,
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '25px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.05)';
          e.target.style.boxShadow = '0 6px 8px rgba(0,0,0,0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.3)';
        }}
      >
        Me Contacter
      </button>

      {/* Bandeau roulant en bas */}
      <ScrollingBanner 
        text={config.bannerText} 
        backgroundColor={config.primaryColor}
        textColor={config.scrollingBanner?.textColor}
        fontSize={config.scrollingBanner?.fontSize}
      />
    </div>
  );
};

export default HomePage;